import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import MuiTextField, {
  TextFieldProps as MuiTextFieldProps,
} from "@mui/material/TextField";

import { TestProps } from "shared/types";
import { toSnakeCase } from "shared/utils";

type AllowedInputVariants = Extract<MuiTextFieldProps["variant"], "outlined">;

type TextFieldProps = Omit<MuiTextFieldProps, "variant"> & {
  variant?: AllowedInputVariants;
} & TestProps;

export interface InputProps extends TestProps, TextFieldProps {}

const TextField = ({
  label,
  fullWidth = true,
  disabled,
  placeholder,
  testId,
  slotProps,
  id,
  sx,
  className,
  ...otherProps
}: InputProps) => {
  // Use provided id (e.g., from Autocomplete) or generate one from label
  const inputId =
    id || (label && typeof label === "string" ? toSnakeCase(label) : undefined);

  return (
    <FormControl
      className={className}
      fullWidth={fullWidth}
      disabled={disabled}
      required={otherProps.required}
    >
      {label && (
        <FormLabel htmlFor={inputId} required={otherProps.required}>
          {label}
        </FormLabel>
      )}
      <MuiTextField
        {...otherProps}
        id={inputId}
        hiddenLabel
        disabled={disabled}
        fullWidth={fullWidth}
        placeholder={placeholder}
        margin="none"
        sx={{
          ...sx,
          "[placeholder]": {
            textOverflow: placeholder ? "ellipsis" : undefined,
          },
        }}
        slotProps={{
          ...slotProps,
          htmlInput: {
            ...slotProps?.htmlInput,
            ...(testId && { "data-testid": testId }),
          },
        }}
      />
    </FormControl>
  );
};

export default TextField;
